import { teamMembers } from "@/mocks/site/content";

export default function TeamSection() {
  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div className="max-w-2xl">
            <div className="text-xs uppercase tracking-[0.18em] text-brand-600 font-bold mb-3">
              The crew that runs the crew
            </div>
            <h4 className="font-display text-3xl md:text-5xl font-bold text-ink-900 leading-tight tracking-tight">
              <a href="#team" className="text-ink-900 hover:text-ink-900 no-underline">
                Meet the leadership.
              </a>
            </h4>
          </div>
          <p className="md:max-w-sm text-sm text-ink-600 leading-relaxed">
            We don't have a marketing department, an investor relations team, or a corporate hotline. Just four humans who really care about getting it right.
          </p>
        </div>

        <div id="team" className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {teamMembers.map((m) => (
            <article key={m.id} className="group">
              <div className="relative rounded-2xl overflow-hidden h-[360px] md:h-[420px] mb-4 bg-cream-100">
                <img
                  src={m.avatar}
                  alt={m.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-x-0 bottom-0 h-1/2 bg-gradient-to-t from-ink-900/80 via-ink-900/30 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-5 flex items-center gap-2">
                  {["ri-linkedin-fill", "ri-mail-line"].map((icon) => (
                    <a
                      key={icon}
                      href="#"
                      className="w-9 h-9 flex items-center justify-center rounded-full bg-white/90 hover:bg-brand-500 text-ink-900 hover:text-white cursor-pointer transition-colors"
                    >
                      <i className={icon}></i>
                    </a>
                  ))}
                </div>
              </div>
              <h3 className="font-display text-lg font-bold text-ink-900 leading-tight">
                {m.name}
              </h3>
              <div className="text-xs font-semibold text-brand-600 uppercase tracking-wider mb-2">
                {m.role}
              </div>
              <p className="text-sm text-ink-600 leading-relaxed">{m.bio}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}